<template>
  <img
    :src="LoyaltyIconSvgGold"
    alt="loyalty-macys-gold-small.svg"
  />
</template>

<script setup>
import LoyaltyIconSvgGold from '@core/csg/src/assets/images/mcom/compressed/loyalty-macys-gold-small.svg';
</script>
